// extracted by mini-css-extract-plugin
export default {"server-message":"ServerMessage_server-message__RGPuf"};